import script from "./tool-header.vue?vue&type=script&setup=true&lang=ts"
export * from "./tool-header.vue?vue&type=script&setup=true&lang=ts"

import "./tool-header.vue?vue&type=style&index=0&id=01b20c7a&lang=scss"

const __exports__ = script;

export default __exports__